import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

//添加elementp-plus后添加如下1.
import ElemnetPlus from 'element-plus'
import 'element-plus/dist/index.full'
import 'element-plus/dist/index.css'


//添加elementp-plus后添加如下2.
//App.use(ElemnetPlus)

createApp(App).use(router).use(ElemnetPlus).mount('#app')

